export default __webpack_public_path__ + "static/media/countriesList.38b43873.jpeg";